import { render, staticRenderFns } from "./CallContacts.vue?vue&type=template&id=aff152ea&"
import script from "./CallContacts.vue?vue&type=script&lang=js&"
export * from "./CallContacts.vue?vue&type=script&lang=js&"
import style0 from "./CallContacts.vue?vue&type=style&index=0&id=aff152ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports